export default "__VITE_ASSET__b96768dc__"